import angular from 'angular';
import { MeurhBureausEquipesAdministradoresController } from './bureaus-equipes-administradores.controller';

export class MeurhBureausEquipesAdministradoresComponent implements angular.IComponentOptions {
    static selector = 'meurhBureausEquipesAdministradores';
    static controller = MeurhBureausEquipesAdministradoresController;
    static template = require('!!html-loader!./bureaus-equipes-administradores.html');
    static bindings = {
        recarga: '<',
        aoSemPermissao: '&',
    };
}
